import React, { useReducer, useContext } from "react";
import { multiFilterReducer as reducer } from "../reducers/multiFilterReducer";
import { multiFilterActions as actions } from "../actions/multiFilterActions";

const initialValue = {
  filters: null,
  selected: {},
  coachName: "",
  showSelectedOnly: false,
};

const multiFilterContext = React.createContext();

const MultiFilterContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <multiFilterContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </multiFilterContext.Provider>
  );
};

export const useMultiFilterContext = () => React.useContext(multiFilterContext);
export default MultiFilterContext;
